import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b0a3bcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "corner corner-tl" }, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "corner corner-tr" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "corner corner-bl" }, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "corner corner-br" }, null, -1 /* HOISTED */))
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "buttonContainer" }
const _hoisted_12 = { class: "stepCounter" }
const _hoisted_13 = { class: "progressBarContainer" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Do you want to exit the tutorial?", -1 /* HOISTED */))
const _hoisted_15 = { class: "buttonContainer" }
const _hoisted_16 = {
  key: 1,
  class: "floatingImageRise"
}
const _hoisted_17 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.ready)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "root",
        class: _normalizeClass(["introductionStep", { hasVideo: $setup.computedStep.video !== undefined }])
      }, [
        ($setup.computedStep.modal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "nge-overlay-blocker",
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
            }, null, 32 /* HYDRATE_EVENTS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(["ng-extend introductionStepAnchor chipBuildIn", [$setup.computedStep.cssClass, { 'nge-no-arrow': !!$props.step.highlight, 'nge-quick-anim': !$setup.computedStep.modal }]]),
          style: _normalizeStyle({ left: $setup.computedStep.left, top: $setup.computedStep.top })
        }, [
          _hoisted_1,
          (!$setup.inExitConfirm)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["chip", { modal: $setup.computedStep.modal, noborder: $setup.computedStep.noborder }]),
                style: _normalizeStyle($setup.chipBounds)
              }, [
                _hoisted_2,
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("button", {
                  class: "exit",
                  onClick: _cache[1] || (_cache[1] = $event => ($setup.inExitConfirm = true))
                }, "×"),
                ($setup.computedStep.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      ($setup.computedStep.titleIcon)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "title-icon",
                            innerHTML: $setup.computedStep.titleIcon
                          }, null, 8 /* PROPS */, _hoisted_7))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...$setup.computedStep.title], (char, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: i,
                          class: "title-letter",
                          style: _normalizeStyle({ animationDelay: ($setup.computedStep.modal ? i * 0.06 : Math.min(i * 0.015, 0.18)) + 's' })
                        }, _toDisplayString(char === ' ' ? '\u00A0' : char), 5 /* TEXT, STYLE */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.computedStep.video)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 1,
                      width: "350",
                      height: "242.81",
                      autoplay: "",
                      loop: "",
                      muted: "",
                      playsinline: "",
                      src: $setup.computedStep.video
                    }, null, 8 /* PROPS */, _hoisted_8))
                  : _createCommentVNode("v-if", true),
                ($setup.computedStep.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      class: "image",
                      src: $setup.computedStep.image
                    }, null, 8 /* PROPS */, _hoisted_9))
                  : _createCommentVNode("v-if", true),
                ($setup.computedStep.html)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "html",
                      innerHTML: $setup.computedStep.html
                    }, null, 8 /* PROPS */, _hoisted_10))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_11, [
                  (!$setup.computedStep.first)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('back'))),
                        class: "back"
                      }, "back"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", _hoisted_12, _toDisplayString($props.stepIndex + 1) + "/" + _toDisplayString($props.totalSteps), 1 /* TEXT */),
                  ($setup.computedStep.last)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = $event => {$setup.launchConfetti(); _ctx.$emit('next')}),
                        class: "next"
                      }, "done"))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.$emit('next'))),
                        class: "next"
                      }, _toDisplayString($setup.computedStep.nextLabel || 'next'), 1 /* TEXT */))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: "progressBar",
                    style: _normalizeStyle({ width: (($props.stepIndex + 1) / $props.totalSteps * 100) + '%' })
                  }, null, 4 /* STYLE */)
                ])
              ], 6 /* CLASS, STYLE */))
            : _createCommentVNode("v-if", true),
          ($setup.inExitConfirm)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["chip exitConfirm", { modal: $setup.computedStep.modal }]),
                style: _normalizeStyle($setup.chipBounds)
              }, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = $event => ($setup.inExitConfirm = false)),
                    class: "next"
                  }, "No"),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = $event => (_ctx.$emit('exitIntro'))),
                    class: "next"
                  }, "Yes")
                ])
              ], 6 /* CLASS, STYLE */))
            : _createCommentVNode("v-if", true)
        ], 6 /* CLASS, STYLE */),
        ($setup.computedStep.floatingImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("img", {
                class: "floatingImageSway",
                src: $setup.computedStep.floatingImage
              }, null, 8 /* PROPS */, _hoisted_17)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}